import { Box, Divider, Skeleton, Tab, Tabs, Typography } from "@mui/material";
import Button from "components/button";
import Dialog from "components/dialog";
import _ from "lodash";
import { Fragment, useState } from "react";

function FareRules({ open, onClose, isLoading, isError, data, flight }) {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0); // shared tab for descriptionType

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleChange = (newValue) => {
    setActiveTab(newValue);
  };

  const segments = Object.keys(data?.data?.response || {}).map((key) => {
    const fare = data?.data?.response[key * 1];

    const segment = flight?.itineraries
      ?.flatMap((itinerary) => itinerary?.segments)
      ?.find((seg) => seg.id === fare?.segmentId);

    // Find fareDetails for this segment from travelerPricings
    const fareDetails =
      flight?.travelerPricings?.[0]?.fareDetailsBySegment?.find(
        (fd) => fd.segmentId === fare?.segmentId
      ) || {};

    return {
      origin: segment?.departure?.iataCode ?? "-",
      destination: segment?.arrival?.iataCode ?? "-",
      fare,
      class: fareDetails.class ?? "-",
      cabin: fareDetails.cabin ?? "-",
      carrierNumber: segment?.number ?? "-",
    };
  });

  return (
    <Dialog open={open} onClose={onClose} overflowY="hidden">
      {isLoading ? (
        <Box width="100%">
          {[...Array(3)].map((_, i) => (
            <Skeleton
              key={i}
              variant="text"
              animation="wave"
              sx={{ bgcolor: "#F1F3F6", width: "100%" }}
            />
          ))}
        </Box>
      ) : isError ? (
        <div className="empty-data-msg">
          <h1 className="medium-font-size title-header">
            There is something wrong! Please try again later!
          </h1>
        </div>
      ) : (
        <Box>
          <Box display="flex" gap={2} mb={2}>
            {segments.map((seg, index) => (
              <Button
                size="small"
                onClick={() => handleChange(index)}
                key={index}
                style={{
                  backgroundColor:
                    activeTab === index ? "rgb(232, 237, 241)" : "transparent",
                }}
              >
                {seg.origin} → {seg.destination}
              </Button>
            ))}
          </Box>

          {/* Segment content */}

          <Typography variant="subtitle1" fontWeight="bold" mb={2}>
            Fare Details
          </Typography>

          <Box
            sx={{
              overflowY: "auto",
              maxHeight: "calc(100vh - 350px)",
              pr: 1,
            }}
          >
            {segments.map((seg, index) =>
              index === activeTab ? (
                <Box key={index} mb={3}>
                  <Typography variant="body2" mb={1.5}>
                    Fare Basis: <strong>{seg.fare?.fareBasis}</strong>
                  </Typography>

                  <Typography variant="body2" mb={1.5}>
                    Cabin: <strong>{seg?.cabin || "N/A"} </strong>
                  </Typography>
                  <Typography variant="body2" mb={1.5}>
                    Carrier Number:
                    <strong> {seg?.carrierNumber || "N/A"}</strong>
                  </Typography>

                  <Typography variant="body2" mb={1.5}>
                    Class:
                    <strong> {seg?.class || "N/A"}</strong>
                  </Typography>
                  <Divider sx={{ mb: 2 }} />

                  <Typography variant="subtitle1" fontWeight="bold">
                    Fare Rules
                  </Typography>

                  {/* Grouped DescriptionType Tabs */}
                  {(() => {
                    const grouped = _.groupBy(
                      seg.fare?.fareNotes?.descriptions || [],
                      "descriptionType"
                    );
                    const types = Object.keys(grouped);

                    return types.length ? (
                      <Box>
                        <Tabs
                          value={selectedTab}
                          onChange={handleChangeTab}
                          variant="scrollable"
                          scrollButtons="auto"
                          // indicatorColor="secondary"
                          // textColor="inherit" // we'll override manually below
                          // sx={{
                          //   mb: 2,
                          //   "& .MuiTab-root": {
                          //     color: "text.secondary", // default tab color
                          //   },
                          //   "& .Mui-selected": {
                          //     color: "#124786 !important", // selected tab text color
                          //   },
                          //   "& .MuiTabs-indicator": {
                          //     backgroundColor: "#124786 !important", // underline
                          //   },
                          // }}
                        >
                          {types.map((type, i) => (
                            <Tab
                              key={type}
                              label={type.toLowerCase()}
                              sx={{ textTransform: "capitalize" }}
                            />
                          ))}
                        </Tabs>

                        {types.map((type, i) => (
                          <Box
                            key={type}
                            role="tabpanel"
                            hidden={selectedTab !== i}
                            mt={1}
                          >
                            {selectedTab === i && (
                              <Box>
                                {grouped[type].map((des, j) => (
                                  <Typography variant="body2" key={j} mb={2}>
                                    {des.text.split("\n").map((line, idx) => (
                                      <Fragment key={idx}>
                                        {line}
                                        {idx <
                                          des.text.split("\n").length - 1 && (
                                          <br />
                                        )}
                                      </Fragment>
                                    ))}
                                  </Typography>
                                ))}
                              </Box>
                            )}
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <Typography>No fare descriptions available.</Typography>
                    );
                  })()}
                </Box>
              ) : null
            )}
          </Box>
        </Box>
      )}

      <Box pt={2} bgcolor="#fff">
        <Button className="w-100" onClick={onClose}>
          Cancel
        </Button>
      </Box>
    </Dialog>
  );
}

export default FareRules;
